const state = {
  language: 'uk',
  usersManager: [],
  usersDraftsman: []
};

const mutations = {
  SET_LANGUAGE(state, lang) {
    state.language = lang;
  },
  SET_USERS_MANAGER(state, users) {
    state.usersManager = users;
  },
  SET_USERS_DRAFTSMAN(state, users) {
    state.usersDraftsman = users;
  }
};

const actions = {
  changeLanguage({ commit }, lang) {
    commit('SET_LANGUAGE', lang);
  }
};

const getters = {
  language: (state) => state.language,
  usersManager: (state) => state.usersManager,
  usersDraftsman: (state) => state.usersDraftsman
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};